import { z } from "zod";
import { signalKindSchema } from "./signals.js";
export const briefStatusSchema = z.enum(["pending", "text_ready", "audio_ready", "failed"]);
export const transcriptLineSchema = z.object({
    t: z.number(),
    text: z.string(),
});
export const briefSchema = z.object({
    id: z.string().uuid(),
    userId: z.string(),
    briefDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    status: briefStatusSchema,
    title: z.string().nullable().default(null),
    subtitle: z.string().nullable().default(null),
    summary: z.string().nullable().default(null),
    transcript: z.array(transcriptLineSchema).default([]),
    sources: z.array(z.string()).default([]),
    audioMime: z.string().nullable().default(null),
    hasAudio: z.boolean().default(false),
    rationale: z.string().nullable().default(null),
    error: z.string().nullable().default(null),
    playedAt: z.coerce.date().nullable().default(null),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
export const briefDraftSchema = z.object({
    title: z.string(),
    /** Short one-line preview rendered as the brief card subtitle.
     *  Distinct from the body summary; previews the read without
     *  re-stating it. Optional for backwards-compat with older drafts. */
    subtitle: z.string().default(""),
    summary: z.string(),
    transcript: z.array(transcriptLineSchema),
    /**
     * User-facing display strings ("Apple Watch", "Sleep log"). Surfaced on
     * the brief card. Distinct from the structured citation fields below,
     * which exist for programmatic provenance, not display.
     */
    sources: z.array(z.string()).default([]),
    rationale: z.string(),
    /**
     * Provenance: the signal *kinds* the brief actually leaned on. Lets us
     * detect briefs whose summary references a signal type not present in
     * the prompt - cheap hallucination signal at the boundary. Not persisted
     * to the briefs table yet (purely agent-side validation).
     */
    citedSignalKinds: z.array(signalKindSchema).default([]),
});
//# sourceMappingURL=brief.js.map